// extracted by mini-css-extract-plugin
export default {"componentWrapper":"ChangeStatus_componentWrapper__dwJJj","actions":"ChangeStatus_actions__QXJPe"};